// export const Baseurl = "http://localhost:4050";
export const Baseurl = "https://instavaluerapi.dexteroustechnology.in";
